// 💬 Ouvre l'assistant « Besoin d'aide ? » depuis une page (« Mes demandes » sans abonnement
// Premium) : App.js écoute cet événement et ouvre la fenêtre de l'assistant
export const OPEN_ASSISTANT_EVENT = "acadeclic:open-assistant";

export const openAssistant = () => window.dispatchEvent(new Event(OPEN_ASSISTANT_EVENT));
